import days from '@anm/constants/days';
import MONTHS from '@anm/constants/months';
import formatAMPM from '@anm/helpers/time/formatAMPM';
import isNumber from 'lodash/fp/isNumber';
import isUndefined from 'lodash/fp/isUndefined';

type Month = 'MMMM' | 'MM';
export type FormatDateOptions = Partial<{
  isHours: boolean;
  monthFormat: Month;
  divider?: string;
  showYear?: boolean;
  hoursSuffix?: string;
  isReplaceValue?: boolean;
}>;

const getDate = (val: string | number, isReplaceValue?: boolean) => {
  const strValue = isReplaceValue && !isNumber(val) ? val.replace(/-/g, '/') : val;
  return isNumber(val) ? new Date(val) : new Date(strValue);
};

export const getDateValues = (val: string | number, options?: FormatDateOptions) => {
  const { monthFormat = 'MM', isReplaceValue = true } = options || {};
  const date = getDate(val, isReplaceValue);
  const monthIndex = date.getMonth();
  const dayIndex = date.getDay();
  const month = monthFormat === 'MMMM' ? MONTHS[monthIndex] : MONTHS[monthIndex].slice(0, 3);

  const dayName = days[dayIndex];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const time = formatAMPM(hours, minutes);

  return [year, month, day, time, dayName] as const;
};

export const getTimezoneAsString = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimeZoneDate = (val: string | number, options?: FormatDateOptions) => {
  const [year, month, day, time] = getDateValues(val, options);

  const timeZone = getTimezoneAsString();

  return `${time} ${timeZone}, ${month} ${day}, ${year}`;
};

const formatDate = (val: string | number, options?: FormatDateOptions) => {
  const { isHours = true, hoursSuffix, showYear = true, divider = ' at ' } = options || {};
  const [year, month, day, time] = getDateValues(val, options);
  const hoursStr = isHours ? `${isUndefined(hoursSuffix) ? divider : hoursSuffix}${time}` : '';

  return `${month} ${day}, ${showYear ? year : ''}${hoursStr}`;
};

export default formatDate;
